import { sendLogToApi } from 'features/logging/sendLogToApi';

type LogOptions = Parameters<typeof sendLogToApi>[0];

export const logWarn = (
  errorOrMessage: LogOptions['errorOrMessage'],
  context?: LogOptions['context']
) => sendLogToApi({ errorOrMessage, context, severity: 'WARNING' });
